import bus from "@/bus";

export default {
  install: (app) => {
    const confirm = async (actionType, actionData) => {
      await bus.global.emit("modal.bottom:open", {
        name: "paid.action.confirmation",
      });

      return new Promise((resolve, reject) => {
        bus.global.emit("confirmation.paid.actions:request", {
          actionType: actionType,
          actionData: actionData,
        });
        bus.global.on("confirmation.paid.actions:confirmed", (properties) => {
          bus.global.emit("modal.bottom:close", {
            name: "paid.action.confirmation",
          });
          resolve(properties);
        });
        bus.global.on("confirmation.paid.actions:rejected", (properties) => {
          bus.global.emit("modal.bottom:close", {
            name: "paid.action.confirmation",
          });
          if (!properties?.userAction) {
            reject();
          }
          bus.global.off("confirmation.paid.actions:rejected");
        });
      });
    };

    app.provide("action.confirm", confirm);
  },
};
